import React from 'react';
import { Helmet } from 'react-helmet';

export default function GeneralSettingsPage() {
    return (
        <div>
            <Helmet>
                <title>Console Defentry - Settings - General</title>
            </Helmet>
            GeneralSettingsPage
        </div>
    );
}
